import {
  PRICE_SUMMARY_REQUEST,
  PRICE_SUMMARY_SUCCESS,
  PRICE_SUMMARY_FAIL,
} from "../actions/priceActions";


const initialState = {

  loading: false,

  summary: null,

  error: null,

};


const priceReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {

    case PRICE_SUMMARY_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case PRICE_SUMMARY_SUCCESS:

      return {

        ...state,

        loading: false,

        summary: action.payload,

        error: null,

      };


    case PRICE_SUMMARY_FAIL:

      return {

        ...state,

        loading: false,

        summary: null,

        error: action.payload,

      };


    default:

      return state;

  }

};


export default priceReducer;